"use strict";

import React from 'react';
import { TouchableHighlight, TouchableNativeFeedback, TouchableOpacity, TouchableWithoutFeedback, ScrollView, FlatList, Switch, TextInput, DrawerLayoutAndroid, View } from 'react-native';
import { State } from './State';
import { Directions } from './Directions';
import { jsx as _jsx } from "react/jsx-runtime";
const NOOP = () => {
  // Do nothing
};
export const GestureHandlerRootView = ({style, children, ...rest}) =>
  /*#__PURE__*/_jsx(View, {style: [{ flex: 1 }, style], ...rest, children});
const PanGestureHandler = View;
const attachGestureHandler = NOOP;
const createGestureHandler = NOOP;
const dropGestureHandler = NOOP;
const updateGestureHandler = NOOP;
const flushOperations = NOOP;
const install = NOOP;
const NativeViewGestureHandler = View;
const TapGestureHandler = View;
const ForceTouchGestureHandler = View;
const LongPressGestureHandler = View;
const PinchGestureHandler = View;
const RotationGestureHandler = View;
const FlingGestureHandler = View;
export const RawButton = ({
  enabled,
  ...rest
}) => /*#__PURE__*/_jsx(TouchableNativeFeedback, {
  disabled: enabled === false,
  ...rest,
  children: /*#__PURE__*/_jsx(View, {})
});
export const BaseButton = RawButton;
export const RectButton = RawButton;
export const BorderlessButton = TouchableNativeFeedback;

// Stub des APIs Gesture v2 utilisées par OptionSliderContent côté natif. Le
// fichier est unifié natif/web et fait `import { Gesture, GestureDetector }`
// au top-level : sans ces stubs, webpack casse même si la branche web n'utilise
// jamais ces APIs au runtime (court-circuit via Platform.OS === 'web').
const chainable = () => {
  const proxy = new Proxy(NOOP, {
    get: () => chainable,
    apply: () => proxy,
  });
  return proxy;
};
export const Gesture = {
  Pan: chainable,
  Tap: chainable,
  LongPress: chainable,
  Fling: chainable,
  Pinch: chainable,
  Rotation: chainable,
  ForceTouch: chainable,
  Native: chainable,
  Manual: chainable,
  Race: chainable,
  Simultaneous: chainable,
  Exclusive: chainable,
};
export const GestureDetector = ({children}) => children;
export default {
  TouchableHighlight,
  TouchableNativeFeedback,
  TouchableOpacity,
  TouchableWithoutFeedback,
  ScrollView,
  FlatList,
  Switch,
  TextInput,
  DrawerLayoutAndroid,
  NativeViewGestureHandler,
  TapGestureHandler,
  ForceTouchGestureHandler,
  LongPressGestureHandler,
  PinchGestureHandler,
  RotationGestureHandler,
  FlingGestureHandler,
  PanGestureHandler,
  attachGestureHandler,
  createGestureHandler,
  dropGestureHandler,
  updateGestureHandler,
  flushOperations,
  install,
  // Probably can be removed
  Directions,
  State
};
//# sourceMappingURL=mocks.js.map